import { useTelegramLogin } from "@core/shared/hooks";
import { SubmitButton } from "@design-system/components/Button";
import { TextInput } from "@design-system/components/Form";
import { trans, plainTrans } from "@mongez/localization";
import { Form } from "@mongez/react-form";
import { FaTelegram } from "react-icons/fa";

export function TelegramPhoneInput() {
  const { loginWithTelegram } = useTelegramLogin();

  return (
    <div className="rounded-lg border border-gray-200 bg-white p-6 shadow-sm dark:border-gray-700 dark:bg-gray-800">
      <div className="mb-6 text-center">
        <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-blue-100 text-blue-600 dark:bg-blue-900/20 dark:text-blue-400">
          <FaTelegram size={32} />
        </div>
        <h3 className="text-xl font-semibold text-gray-900 dark:text-gray-100">
          {trans("auth.telegram.loginWithTelegram")}
        </h3>
        <p className="mt-2 text-sm text-gray-600 dark:text-gray-400">
          {trans("auth.telegram.enterPhoneOrEmail")}
        </p>
      </div>

      <Form onSubmit={loginWithTelegram} className="space-y-4">
        <TextInput
          name="phoneOrEmail"
          label={trans("auth.telegram.phoneOrEmail")}
          placeholder={plainTrans("auth.telegram.phoneOrEmailPlaceholder")}
          required
        />

        <SubmitButton className="w-full">
          {trans("auth.telegram.sendOTP")}
        </SubmitButton>
      </Form>
    </div>
  );
}
